module.exports = __webpack_public_path__ + "static/scale-model-of-turpin-park-in-lewisville-texas-8a3d36335326b556354302550f91e258.png";